// extracted by mini-css-extract-plugin
module.exports = {"form":"R+S93","fields-container":"yBc3f","terms":"jwN7X","social-btns":"xveV8","footer-logo":"b-gDM"};